import HeroHeader from '../../components/HeroHeader';

const Home = () => {
  return <HeroHeader />;
};

export default Home;
